import StateDropdown from 'components/RenewalQuestionnaireComp/DriversOHM/StateDropdown';
import React from 'react'

const AddressGaraged_Vehicles = ({ vehicle, id, updateVehicleLocation }) => {
    
    return (
        <>
            {/* Garaged Location */}
            <p className="fw-bold text-primary">
                Where will this vehicle be garaged overnight?*
            </p>

            {/* Overnight address fields */}
            <>
                {/* Address */}
                <div className="form-group-spacer mt-2 col-8">
                    <input type={"text"} className="form-control"
                        placeholder="Street Address" maxLength={60}
                        value={vehicle?.garagedStreetAddress || ""}
                        onChange={(e) => {
                            updateVehicleLocation("garagedStreetAddress", vehicle, id, e.target.value);
                        }}
                    />
                </div>
                {/* City */}
                <div className="form-group-spacer mt-2 col-8">
                    <input type={"text"} className="form-control"
                        placeholder="City" maxLength={64}
                        value={vehicle?.garagedCity || ""}
                        onChange={(e) => {
                            updateVehicleLocation("garagedCity", vehicle, id, e.target.value)
                        }}
                    />
                </div>
                <div className="row form-group">
                    {/* State */}
                    <div className="col-4 mt-2">
                        <select className="btn btn-default btn-group dropdown-toggle filter-option"
                            value={vehicle?.garagedState || ""}
                            onChange={(e) => updateVehicleLocation("garagedState", vehicle, id, e.target.value)}
                        >
                            {StateDropdown()}
                        </select>
                    </div>
                    {/* Zip */}
                    <div className="col-4 mt-2 ms-2">
                        <input className="form-control"
                            placeholder="Zip Code" maxLength={5}
                            value={vehicle?.garagedZipCode ? vehicle?.garagedZipCode : ""}
                            onChange={(e) => {
                                updateVehicleLocation("garagedZipCode", vehicle, id, e.target.value.replace(/\D/g, ""))
                            }}
                        />
                    </div>
                </div>
            </>
        </>
    )
}

export default AddressGaraged_Vehicles